<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>LISTE {{ nomFenetre.toUpperCase() }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <mat-card class="example-card carClass">
      <mat-card-content>
        <div class="btn">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Du</mat-label>
              <input
                matInput
                [matDatepicker]="dateDebut"
                placeholder="Du"
                [(ngModel)]="date_Debut"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateDebut"
              ></mat-datepicker-toggle>
              <mat-datepicker #dateDebut></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Au</mat-label>
              <input
                matInput
                [matDatepicker]="dateFin"
                placeholder="Au"
                [(ngModel)]="date_Fin"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateFin"
              ></mat-datepicker-toggle>
              <mat-datepicker #dateFin></mat-datepicker>
            </mat-form-field>
            <!-- <mat-form-field     appearance="outline"  *ngIf="fenetre == '1'">
                            <mat-label>&Eacute;tat</mat-label>
                            <mat-select name="xxx" #xxxx="ngModel" [(ngModel)]="reglerOrNot" placeholder="&Eacute;tat" (selectionChange)="onEtatChange()" required>
                                <mat-option value="0">Tout</mat-option>
                                <mat-option value="1">Facture réglée</mat-option>
                                <mat-option value="2">Facture non réglée</mat-option>
                            </mat-select>
                        </mat-form-field>     -->
          </div>
          <div>
            <button
              *ngIf="!showButton"
              type="button"
              (click)="choisirDocument()"
              mat-raised-button
              class="colorGreen button-row"
            >
              <mat-icon>mouse</mat-icon>Choisir
            </button>
            <button
              type="button"
              (click)="getListeDocument()"
              mat-raised-button
              class="colorGreen button-row"
            >
              <mat-icon>search</mat-icon>Filtrer
            </button>
            <button
              *ngIf="showButton"
              type="button"
              (click)="goToDocument('2')"
              mat-raised-button
              class="colorBlue button-row"
            >
              <mat-icon>edit</mat-icon>Modifier
            </button>
            <button
              *ngIf="showButton"
              type="button"
              (click)="goToDocument('3')"
              mat-raised-button
              class="colorGray button-row"
            >
              <mat-icon>import_contacts</mat-icon>Consulter
            </button>
            <button
              *ngIf="!showButton"
              type="button"
              (click)="closeWindow()"
              mat-raised-button
              class="colorRed button-row"
            >
              <mat-icon>close</mat-icon>Fermer
            </button>
            <button
              type="button"
              (click)="exportToExcel()"
              mat-raised-button
              class="colorGreen button-row"
            >
              <mat-icon>arrow_downward</mat-icon>Export Excel
            </button>
          </div>
        </div>

        <app-avt-listes
          *ngIf="showDocument"
          #listeDocumentComponen
          [heightTable]="'400'"
          [dataSourceBrut]=""
          [displayedColumnsBrut]="columnsDocument"
        >
        </app-avt-listes>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
